const CONFIG_KEY = "vlf_gps_config";

export const ACWR_DEFAULTS = {
	acwrLow: 0.8,   // sotto → "Basso"
	acwrHigh: 1.3,  // sopra → "Attenzione"
	acwrMax: 1.5,   // sopra → "Alto rischio"
};

export const getAcwrConfig = () => {
	try {
		const stored = JSON.parse(localStorage.getItem(CONFIG_KEY) ?? "{}");
		return {...ACWR_DEFAULTS, ...stored};
	} catch {
		return {...ACWR_DEFAULTS};
	}
};

export const saveAcwrConfig = (config) => {
	localStorage.setItem(CONFIG_KEY, JSON.stringify(config));
};
